export default {
  title: "Attachment details",
  label_description: "Description",
  check_box_allow_downloads: "Allow downloads",
}
